import { render, staticRenderFns } from "./NoticeStore.vue?vue&type=template&id=4d8a72c8&scoped=true&"
import script from "./NoticeStore.vue?vue&type=script&lang=js&"
export * from "./NoticeStore.vue?vue&type=script&lang=js&"
import style0 from "./NoticeStore.vue?vue&type=style&index=0&id=4d8a72c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a72c8",
  null
  
)

export default component.exports